import useFetch from '@hooks/useFetch';
import { processSimilarAndOtherCourses } from '@api/hooks/class/utils';
import { emptyList } from '@constants/empty';
import reduxFreeFetcher from '@api/fetchers';

const similarCourseMiddleware = (useSWRNext) => (key, fetcher, config) => {
  const swr = useSWRNext(key, fetcher, config);
  const processedCourseData = swr.data?.processed
    ? swr.data
    : processSimilarAndOtherCourses(swr.data);

  return {
    ...swr,
    data: processedCourseData
  };
};

export const getKey = (classUID) =>
  `v1/search_v3/special_classes/${classUID}/v2/`;

const useSimilarAndOtherCourses = (
  classUID,
  options = { revalidateOnMount: false, fallbackData: undefined }
) => {
  const key = getKey(classUID);

  const {
    data: similarAndOtherCourses,
    isValidating,
    mutate,
    ...rest
  } = useFetch(
    key,
    {},
    {
      use: [similarCourseMiddleware],
      revalidateOnMount: options.revalidateOnMount,
      fallbackData: options.fallbackData
    }
  );

  const onToggleEnroll = async (
    courseUIDToEnroll,
    shouldEnroll = false,
    sendEmail = false,
    prodigyKey = null
  ) => {
    try {
      await reduxFreeFetcher(`v2/uplus/programmes/${courseUIDToEnroll}/save/`, {
        requestType: 'POST',
        body: {
          enroll: shouldEnroll,
          send_email: sendEmail,
          prodigy_key: prodigyKey
        }
      });

      return await mutate();
    } catch (err) {
      return {
        error: {
          message: `Unable to ${
            shouldEnroll.isEnrolled ? 'enroll' : 'un-enroll'
          }. Please try again!`
        }
      };
    }
  };

  return {
    key,
    similarAndOtherCourses: similarAndOtherCourses?.results || emptyList,
    onToggleEnroll,
    mutate,
    isValidating,
    ...rest
  };
};

export default useSimilarAndOtherCourses;
